import { useMemo } from "react";
import { calculateScore } from "../utils/calculateScore";
import { GameData } from "../../game/Types/GameTypes";
import { Quiz } from "../../../API";

export function useGameResults(
  gameDatas: GameData[],
  quiz: Quiz | null | undefined
) {
  const sorted = useMemo(() => {
    if (!gameDatas) return [];
    return gameDatas.sort((a, b) => {
      const aScore = calculateScore(a.answerResults);
      const bScore = calculateScore(b.answerResults);
      return bScore - aScore;
    });
  }, [gameDatas]);

  const completed = useMemo(
    () =>
      gameDatas.filter((data) => {
        const isComplete =
          data.answerResults.length === quiz?.Questions?.items.length;

        return isComplete;
      }),
    [gameDatas]
  );
  const incomplete = useMemo(
    () =>
      gameDatas.filter((data) => {
        const isComplete =
          data.answerResults.length === quiz?.Questions?.items.length;

        return !isComplete;
      }),
    [gameDatas]
  );

  const total = useMemo(() => gameDatas.length, [gameDatas]);

  const teamBests = useMemo(() => {
    return completed;
  }, [completed]);

  const allAnswerResults = useMemo(() => {
    if (!gameDatas) return [];
    const allAnswerResults = gameDatas.flatMap(
      (result) => result.answerResults
    );
    return allAnswerResults;
  }, [gameDatas]);

  return {
    all: gameDatas,
    sorted,
    studentBests: teamBests,
    completed,
    incomplete,
    total,
    allAnswerResults,
  };
}
